import Vue from 'vue'
import Vuex from 'vuex'

import User from './modules/user.js'
import Connect from './modules/connect.js'
import Tariffs from './modules/tariffs.js'
import System from './modules/system.js'
import Slider from './modules/slider.js'
import News from './modules/news.js'
import Offices from './modules/offices.js'
import TariffBlock from './modules/tariffBlock.js'
import Process from './modules/process.js'
import Payment from './modules/payment.js'
import Actions from './modules/actions.js'
import Recovery from './modules/recovery.js'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        User,
        Connect,
        Tariffs,
        System,
        Slider,
        News,
        Offices,
        TariffBlock,
        Process,
        Payment,
        Actions,
        Recovery,
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js